export default "__VITE_ASSET__9fb35f85__"